module.exports = __webpack_public_path__ + "static/media/beetroot.875f177a.jpg";